import * as moment from "moment";
import * as localisationHelper from "localisationHelper";

// Types
import Moment = moment.Moment;

// Enums
import { DateTimeWorkflowStates } from "Content/ts/Shared/Controls/DateTime/Services/workflowStates";

// Models
import { TimeConfiguration } from "Content/ts/Models/Shared/DateTime/timePickerConfiguration";
import { DateTimeConfiguration } from "Content/ts/Models/Shared/DateTime/dateTimePickerConfiguration";
import { DateConfiguration, DatePickerLibraryEvents } from "Content/ts/Models/Shared/DateTime/datePickerConfiguration";

export const Deps = {
    LocalisationHelper: localisationHelper
};

export module DateTimePickerServices {
    export function HasDateConfigurationProvided(configuration: DateTimeConfiguration): boolean {
        return configuration && configuration.DateConfiguration != null && configuration.DateConfiguration != undefined;
    };

    export function HasTimeConfigurationProvided(configuration: DateTimeConfiguration): boolean {
        return configuration && configuration.TimeConfiguration != null && configuration.TimeConfiguration != undefined;
    };

    export function ConfigureConfigurationProperties(configuration: DateTimeConfiguration): DateTimeConfiguration {
        // Purpose  :   If the component hasn't been provided the DateConfiguration (might not be needed due to
        //              component state), then ensure the date configuration has been newed up in order to stop
        //              functionality breaking under the hood.
        if (!configuration.DateConfiguration) {
            configuration.DateConfiguration = <DateConfiguration>{};
        }

        // Purpose  :   If the component hasn't been provided the TimeConfiguration (might not be needed due to
        //              component state), then ensure the date configuration has been newed up in order to stop
        //              functionality breaking under the hood.
        if (!configuration.TimeConfiguration) {
            configuration.TimeConfiguration = <TimeConfiguration>{};
        }

        // Purpose  :   Rather than the library rendering 2 hidden away clear functions, when using 'DateTimeMode' 
        //              we have 1 button always displayed on the page. Due to this the library's version of clearing
        //              a date is hidden by default in this mode.
        if (configuration.ComponentState == DateTimeWorkflowStates.DateTimeMode) {
            configuration.DateConfiguration.AllowClear = false;
            configuration.TimeConfiguration.AllowClear = false;
        }

        return configuration;
    };

    export function FormatDateTimeComputedRead(value: KnockoutObservable<Moment>, hasSetProperty: KnockoutObservable<boolean>, componentState: DateTimeWorkflowStates): Moment {
        if (!value()) {
            return null;
        }

        if (componentState == DateTimeWorkflowStates.DateTimeMode) {
            if (hasSetProperty()) {
                return value();
            }

            return null;
        }

        return value();
    };

    export function ConfigureSharedDateTimeMarkup(element: JQuery<HTMLElement>, value: KnockoutObservable<Moment>, icon: string, screenReaderText: string,
        expectedMomentFormat: string): void {
        const dateTimePicker = $(element).data("Zebra_DatePicker") as DatePickerLibraryEvents;
        const elementMarkupOverride =
            `
                ${icon}
                <span class="sr-only">${screenReaderText}</span>
            `;

        element.next().html(elementMarkupOverride);

        value.subscribe((value?: Moment) => {
            if (!value) {
                // Purpose  :   The date/time can be cleared out by other means not connected to Zebra (e.g. Clear Filter in a Search UI)
                //              so this ensures the value is cleared from the picker too.
                dateTimePicker.clear_date();
            } else {
                // Purpose  :   The date/time can be updated by other means not connected to Zebra (e.g. Online Ticketing Next Session Date)
                //              so this ensures the value is updated in the picker too.
                dateTimePicker.set_date(value.format(expectedMomentFormat))
            }
        });

        ConfigureDateTimeResizeEvents(element, dateTimePicker);
    };

    // Purpose  :   There seems to be an issue with Zebra calculating the 'top' position when handling modals. Tried a number of 
    //              fixes to address this problem but to no avail and cannot determine if it's Knockout/RequireJS rendering issue 
    //              or something embedded into Bootstrap.For now this seems to the the best solution which won't take days to resolve
    function ConfigureDateTimeResizeEvents(element: JQuery<HTMLElement>, dateTimePicker: DatePickerLibraryEvents): void {
        const parentWithModal =
            element.parents(".modal-body")[0];
        if (parentWithModal != null && parentWithModal != undefined) {
            element.next().css("top", 8.5);
        }

        $(window).resize(() => {
            dateTimePicker.update();
        });
    };
}